<template>
  <v-list :class="{'mt-0 pt-0': $vuetify.display.smAndDown}"
          :selected="selectedItems"
          @update:selected="updateSelected"
  >
    <v-list-item
      v-for="(item, i) in items"
      :value="item"
      :key="`item_${i}`"
      class="pa-0"
    >
      <template v-if="item.title === 'separator'">
        <v-divider :key="i"></v-divider>
      </template>
      <template v-else>
        <slot name="section" :item="item">
          <ProjectNavigationSection :key="item.key"
                                    :title="item.title"
                                    :to="item.key"
                                    :icon="item.icon"
          />
        </slot>
      </template>
    </v-list-item>
  </v-list>
</template>

<script>
  import ProjectNavigationSection from '@/project/navigation-drawer/ProjectNavigationSection.vue'

  export default {
    name: 'ProjectNavigationDrawerLayout',
    components: { ProjectNavigationSection },
    props: {
      items: {
        type: Array,
        required: true,
      },
      defaultSelectedItem: {
        required: true,
        default: '',
      },
    },
    data () {
      return {
        selectedItems: [],
      }
    },
    watch: {
      defaultSelectedItem: {
        handler (value) {
          this.selectedItems = [value]
        },
        immediate: true,
      },
    },
    methods: {
      updateSelected (value) {
        // If the value is an object, it means that the user clicked on a section already selected
        if (typeof value != 'object') {
          this.selectedItems = value
        }
      },
    },
  }
</script>
